module.exports = __webpack_public_path__ + "r-v3/img/icon_music.52435d98.svg";